export enum PropertyType {
  RESIDENTIAL = 1,
  VILLAS = 2,
  PLOT = 3,
  COMMERCIAL = 4
}

export const PROPERTY_TYPES_LIST: {
  [key in PropertyType]: string;
} = {
  [PropertyType.RESIDENTIAL]: 'Residential',
  [PropertyType.VILLAS]: 'Villa',
  [PropertyType.PLOT]: 'Plot',
  [PropertyType.COMMERCIAL]: 'Commercial'
};
